import React, { useRef, useContext } from 'react';
import { Picker } from 'emoji-mart';

import { ThemeContext } from 'context/ThemeContext';

import Popout from './popout';

import 'emoji-mart/css/emoji-mart.css';

const EmojiPicker = ({ onSelect, children }) => {
    const popoutCtrl = useRef(null);
    const themeCtx = useContext(ThemeContext);

    const hide = () => {
        popoutCtrl.current?.hide();
    }

    const handleToggleClick = () => {
        popoutCtrl.current?.show();
    }

    const handleSelect = emoji => {
        onSelect && onSelect(emoji)

        hide();
    }

    const childrenWithProps = React.Children.map(children, child => {
        return React.cloneElement(child, {
            onClick: handleToggleClick
        });
    });

    return (
        <React.Fragment>
            { childrenWithProps }

            <Popout className="auto-size emoji-picker-popout" defaultXPosition="left" xAlign="right" defaultYPosition="top" provideController={popoutCtrl}>
                <Picker theme={themeCtx?.theme === 'dark' ? 'dark' : 'light'} onSelect={handleSelect} />
            </Popout>
        </React.Fragment>
    )
}

export default EmojiPicker;
